module.exports = __webpack_public_path__ + "static/media/backgroundImg.b86c2218.png";